import VerticalRail from './VerticalRail';

export default VerticalRail;
